import React, { createContext } from 'react';
import axios from "../../utils/axios";
import { cWarn } from './CustomLogger';

export const BookingDialogueContext = createContext();

class BookingDialogueContextProvider extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            approvalBooking:{},
            detailBooking:{},
            approvalBookingStudentId:false,
            showStaffApprovalDialogue:false,
            showDetailDialogue:false,
            isLoading: true,
        };
    }

    showStaffApproval(booking,studentId){
        this.setState({
            showStaffApprovalDialogue:true,
            approvalBookingStudentId:studentId,
            approvalBooking:booking
        });
    }

    approveBooking(callBack){
        this.setState({
            showStaffApprovalDialogue:false,
        })
        const apiPath = `${process.env.REACT_APP_API_URL}/staffapprovebooking`;
        axios.post(apiPath,{
            bookingId:this.state.approvalBooking.id
        },{
            timeout: 300000,
            withCredentials:true
        }).then(() => {
            if(callBack){
                callBack();
            }
        }).catch(err => {
           cWarn(err);
        });
    }

    

    bringUpDetailDialogue(booking){

        if(typeof booking === 'number'){
            // grab the details of the booking based on the booking id

            const apiPath = `${process.env.REACT_APP_API_URL}/id/${booking}`;
            axios.get(apiPath,{
                timeout: 300000,
                withCredentials:true
            }).then((res) => {
                this.setState({
                    showDetailDialogue:true,
                    detailBooking:res.data
                });
            }).catch(err => {
               cWarn(err);
            });

        }
        else{
            this.setState({
                showDetailDialogue:true,
                detailBooking:booking
            });
        }

        
    }

    render(){
        return (
            <BookingDialogueContext.Provider value={{
                ...this.state,
                setState: this.setState.bind(this),
                approveBooking:this.approveBooking.bind(this),
                showStaffApproval: this.showStaffApproval.bind(this),
                bringUpDetailDialogue: this.bringUpDetailDialogue.bind(this),
            }}>
                {this.props.children}
            </BookingDialogueContext.Provider>
        );
    }


}
export default BookingDialogueContextProvider;